import React from 'react';
import ChartBox from '../../Custom/ChartBox';
import ChartEnergyConsumptionHistorical from './ChartEnergyConsumptionHistorical';

const EnergyConsumptionHistorical = ({ data, isLoading }) => (
  <div>
    <ChartBox title={'Energy Consumption Historical'}>
      <ChartEnergyConsumptionHistorical data={data} isLoading={isLoading} />
    </ChartBox>
  </div>
);

export default EnergyConsumptionHistorical;
